/**
 * fetchVariantGalleryDocument - A product section as the Section Rendering API renders it for one
 * variant, parsed
 *
 * The response is exactly what the page shows for that variant (lead image, hidden variant media
 * and all), so callers take its `media-gallery` rather than rebuilding one. Rejects on a non-2xx
 * response and on abort.
 */
export const fetchVariantGalleryDocument = async ({
	pageUrl,
	sectionId,
	variantId,
	signal,
}: {
	/** The product page the section belongs to. */
	pageUrl: string;
	sectionId: string;
	variantId: number;
	signal?: AbortSignal;
}): Promise<Document> => {
	const url = new URL(pageUrl, window.location.origin);
	url.searchParams.set('variant', String(variantId));
	url.searchParams.set('section_id', sectionId);

	const response = await fetch(url, { signal });
	if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);

	return new DOMParser().parseFromString(await response.text(), 'text/html');
};

/** The theme's gallery custom element, in a live section or a fetched one. */
export const VARIANT_GALLERY_SELECTOR = 'media-gallery';
